import { Decorable, GConstructor } from "./general";

export interface ImagePayload {
  src: string;
  altText: string;
}

export interface ImageMixinPayload {
  __src: string;
  __altText: string;
}

export type SerializedImage = {
  src: string;
  altText: string;
};

type ImageCtor = GConstructor<Decorable & ImageMixinPayload>;

export function ImageMixin<TBase extends ImageCtor>(Base: TBase) {
  return class Image extends Base {
    __src!: string;
    __altText!: string;

    constructor(...args: any[]) {
      const [src, altText, ...rest] = args;
      super(...rest);
      this.__src = src || '';
      this.__altText = altText || '';
    }

    getSrc() {
      const self = this.getLatest();
      return self.__src;
    }

    setSrc(src: string) {
      const self = this.getWritable();
      self.__src = src;
    }

    getAltText() {
      const self = this.getLatest();
      return self.__altText;
    }
  };
}

type Image = InstanceType<ReturnType<typeof ImageMixin<ImageCtor>>>;

export const $isImageNode = (node: unknown): node is Image => {
  return Boolean(node && typeof node === 'object' && '__src' in node && '__altText' in node);
}